export default __webpack_public_path__ + "static/media/mission-img.27d51c90.webp";